import React from "react";

const YoutubeThumbnailPreview = ({
  isVisible,
  onImageError,
  position,
  thumbnailUrl,
}) => {
  if (!isVisible || !thumbnailUrl) return null;

  const previewStyle = {
    left: `${position.left}px`,
    top: `${position.top}px`,
  };

  return (
    <div
      className="pointer-events-none fixed z-[9999] w-[240px] overflow-hidden rounded-md border border-border bg-surface shadow-xl"
      style={previewStyle}
    >
      <img
        alt="YouTube video thumbnail"
        className="aspect-video w-full bg-surface-muted object-cover"
        onError={onImageError}
        src={thumbnailUrl}
      />
    </div>
  );
};

export default YoutubeThumbnailPreview;
